var _rect, _path, _circle, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _line2, _rect7, _line3, _rect8, _line4, _rect9, _line5, _rect10, _line6, _rect11, _line7, _rect12, _line8, _rect13, _line9, _rect14, _line10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDealPlaceholderBannerDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 250,
    viewBox: "0 0 502 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 502,
    height: 250,
    fill: "#1A202C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0779 159.607C31.5473 161.773 30.4411 166.391 32.6072 169.922C34.7733 173.453 39.3914 174.559 42.9221 172.393L35.0779 159.607ZM60.4746 144.026L35.0779 159.607L42.9221 172.393L68.3187 156.812L60.4746 144.026Z",
    fill: "#4A5568"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 124.5,
    r: 56,
    fill: "#1A202C",
    stroke: "#4A5568",
    strokeWidth: 15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 107,
    width: 15,
    height: 38,
    rx: 7.5,
    fill: "#4A5568"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 100.677,
    y: 96,
    width: 14.6462,
    height: 53,
    rx: 7.32308,
    fill: "#4A5568"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 112,
    width: 14.6462,
    height: 27.9324,
    rx: 7.32308,
    fill: "#4A5568"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 197.5,
    y: 88.5,
    width: 14,
    height: 86,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 204.5,
    y1: 62,
    x2: 204.5,
    y2: 201,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 63.5,
    width: 14,
    height: 30,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 231.5,
    y1: 37,
    x2: 231.5,
    y2: 176,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 251.5,
    y: 147.5,
    width: 14,
    height: 38,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 258.5,
    y1: 73,
    x2: 258.5,
    y2: 212,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 278.5,
    y: 55.5,
    width: 14,
    height: 93,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 285.5,
    y1: 36,
    x2: 285.5,
    y2: 175,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 305.5,
    y: 84.5,
    width: 14,
    height: 51,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 312.5,
    y1: 58,
    x2: 312.5,
    y2: 160,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 332.5,
    y: 85.5,
    width: 14,
    height: 86,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 339.5,
    y1: 59,
    x2: 339.5,
    y2: 198,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 359.5,
    y: 123.5,
    width: 14,
    height: 23,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 366.5,
    y1: 34,
    x2: 366.5,
    y2: 173,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 386.5,
    y: 144.5,
    width: 14,
    height: 38,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 393.5,
    y1: 70,
    x2: 393.5,
    y2: 209,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 413.5,
    y: 59.5,
    width: 14,
    height: 86,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 420.5,
    y1: 33,
    x2: 420.5,
    y2: 172,
    stroke: "#4A5568",
    strokeWidth: 3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 440.5,
    y: 81.5,
    width: 14,
    height: 86,
    rx: 7,
    fill: "#4A5568",
    stroke: "#4A5568"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 447.5,
    y1: 55,
    x2: 447.5,
    y2: 194,
    stroke: "#4A5568",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealPlaceholderBannerDark);
export default __webpack_public_path__ + "static/media/deal_placeholder_banner_dark.f0decdd4ac27e0157a4dd6482b77a85a.svg";
export { ForwardRef as ReactComponent };